module.exports = __webpack_public_path__ + "static/third-step-apartados-d4085d4141c47be9f700d31d8f42cd23.svg";